import React from 'react';
export function AboutDestaMeet() {
  return <section className="py-16 bg-white" data-id="element-154">
      <div className="container mx-auto px-4 md:px-6" data-id="element-155">
        <div className="max-w-4xl mx-auto" data-id="element-156">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-6 text-center" data-id="element-157">
            About <span className="text-[#0099A1]" data-id="element-158">DestaMeet</span>
          </h2>
          <div className="prose prose-lg max-w-none text-[#374047]/80 text-center space-y-4" data-id="element-159">
            <p data-id="element-160">
              Destameet transforms corporate events into experiences employees
              actually love. We may design events, but we really design moments
              that inspire your team, celebrate their achievements and build
              brand loyalty. A Destameet experience leaves teams energized,
              inspired and more connected to your brand. Managing logistics is
              obvious, but what we really do is elevate employee satisfaction,
              engagement and brand reputation.
            </p>
            <p className="text-xl font-medium text-[#0099A1] mt-6" data-id="element-161">
              Because work shouldn't have to be within 4 walls.
            </p>
          </div>
        </div>
      </div>
    </section>;
}